const lazyLoadingBackgroundImage = () => {
    document.addEventListener('DOMContentLoaded', function() {
        var lazyBackgrounds = [].slice.call(
            document.querySelectorAll('.lazy-background-image')
        );

        if ('IntersectionObserver' in window) {
            let lazyBackgroundObserver = new IntersectionObserver(function( entries ) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        if (entry.target.dataset.imgSrc) {
                            entry.target.style.backgroundImage = `url('${entry.target.dataset.imgSrc}')`;
                        } else if (entry.target.dataset.index) {
                            console.log('lazyloading', entry.target.dataset.index);
                            entry.target.classList.add(`lazy-background-image-load-${entry.target.dataset.index}`)
                        }

                        lazyBackgroundObserver.unobserve(entry.target);
                    }
                });
            });

            lazyBackgrounds.forEach(function(lazyBackground) {
                lazyBackgroundObserver.observe(lazyBackground);
            });
        }
    });
}

export default lazyLoadingBackgroundImage;



// WEBPACK FOOTER //
// ./scripts/miscellaneous/lazyLoadingBackgroundImage.js